module.exports = {
  "id": "en",
  "data": {
    "long": {
      "years": {
        "one": "{0} year",
        "other": "{0} years"
      },
      "months": {
        "one": "{0} month",
        "other": "{0} months"
      },
      "weeks": {
        "one": "{0} week",
        "other": "{0} weeks"
      },
      "days": {
        "one": "{0} day",
        "other": "{0} days"
      },
      "hours": {
        "one": "{0} hour",
        "other": "{0} hours"
      },
      "minutes": {
        "one": "{0} minute",
        "other": "{0} minutes"
      },
      "seconds": {
        "one": "{0} second",
        "other": "{0} seconds"
      }
    },
    "narrow": {
      "years": {
        "one": "{0}y",
        "other": "{0}y"
      },
      "months": {
        "one": "{0}m",
        "other": "{0}m"
      },
      "weeks": {
        "one": "{0}w",
        "other": "{0}w"
      },
      "days": {
        "one": "{0}d",
        "other": "{0}d"
      },
      "hours": {
        "one": "{0}h",
        "other": "{0}h"
      },
      "minutes": {
        "one": "{0}m",
        "other": "{0}m"
      },
      "seconds": {
        "one": "{0}s",
        "other": "{0}s"
      }
    },
    "short": {
      "years": {
        "one": "{0} yr",
        "other": "{0} yrs"
      },
      "months": {
        "one": "{0} mth",
        "other": "{0} mths"
      },
      "weeks": {
        "one": "{0} wk",
        "other": "{0} wks"
      },
      "days": {
        "one": "{0} day",
        "other": "{0} days"
      },
      "hours": {
        "one": "{0} hr",
        "other": "{0} hr"
      },
      "minutes": {
        "one": "{0} min",
        "other": "{0} min"
      },
      "seconds": {
        "one": "{0} sec",
        "other": "{0} sec"
      }
    }
  }
};
